module.exports = __webpack_public_path__ + "img/cardexp.ce6ecb68.svg";